import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import axios from 'axios';

import MainLayout from './view/layouts/MainLayout';
import HomeScreen from './view/screens/home/HomeScreen';
import DetailPostScreen from './view/screens/post/PostScreen';
import Error404 from './view/compoment/Error404';
import ContactScreen from './view/screens/contact/ContactScreen';
import EnrollmentScreen from './view/screens/enrollment/EnrollmentScreen';
import GoogleCallbackHandler from './view/screens/login/compoment/GoogleCallbackHandler';
import ScrollToTop from './view/compoment/ScrollToTop';
import ListMemberScreen from './view/screens/member/ListMemberScreen';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Accept'] = 'application/json';
// axios.defaults.headers.post['Access-Control-Allow-Origin'] =
//   process.env.REACT_APP_CLIENT_URL || '*';

function App() {
  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      <Routes>
        <Route
          path="/auth/google/callback"
          element={<GoogleCallbackHandler />}
        />

        <Route
          path="/search"
          element={
            <MainLayout>
              <ListMemberScreen />
            </MainLayout>
          }
        />

        <Route
          path="/:title/:slug"
          element={
            <MainLayout>
              <DetailPostScreen />
            </MainLayout>
          }
        />

        <Route
          path="/:title"
          element={
            <MainLayout>
              <DetailPostScreen />
            </MainLayout>
          }
        />

        <Route
          path="/lien-he"
          element={
            <MainLayout>
              <ContactScreen />
            </MainLayout>
          }
        />

        <Route
          path="/tuyen-dung/:slug"
          element={
            <MainLayout>
              <EnrollmentScreen />
            </MainLayout>
          }
        />

        <Route
          path="/"
          element={
            <MainLayout>
              <HomeScreen />
            </MainLayout>
          }
        />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
